import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { StockTakeDto, StockTakeServiceProxy, TokenAuthServiceProxy, Status, EntityDto } from '@shared/service-proxies/service-proxies';
import { CreateOrEditStockTakeModalComponent } from './create-or-edit-stocktake-modal.component';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';

@Component({
    templateUrl: './stocktakes.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class StockTakesComponent extends AppComponentBase {
    @ViewChild('createOrEditStockTakeModal', { static: true })
    createOrEditStockTakeModal: CreateOrEditStockTakeModalComponent;

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;
    advancedFiltersAreShown = false;
    filterText: '';
    status = Status;
    constructor(
        injector: Injector,
        private _stockTakeServiceProxy: StockTakeServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        public utilsService: UtilsService,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    getStockTakes(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();

        this._stockTakeServiceProxy
            .getAll(
                this.filterText,
                this.appSession.user.locationId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createStockTake(): void {
        this.createOrEditStockTakeModal.show();
    }

    deleteStockTake(stockTake: StockTakeDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._stockTakeServiceProxy.deleteStockTakes(stockTake.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }

    updateStock(stockTake: StockTakeDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                var request = new EntityDto();
                request.id = stockTake.id;
                this._stockTakeServiceProxy.updateStock(request).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyUpdatedStock'));
                });
            }
        });
    }
    updateFullStock(stockTake: StockTakeDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                var request = new EntityDto();
                request.id = stockTake.id;
                this._stockTakeServiceProxy.updateFullStockTake(request).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyUpdatedStock'));
                });
            }
        });
    }

    

    resetFilters(): void {
        this.getStockTakes();
    }

}
